import { render, staticRenderFns } from "./businessTripEdit.vue?vue&type=template&id=4f4385c6&scoped=true"
import script from "./businessTripEdit.vue?vue&type=script&lang=js"
export * from "./businessTripEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4385c6",
  null
  
)

export default component.exports